import { Params } from ".";

export const searchAcademicCalendars = (params?: Params) => /* GraphQL */ `
query ${params?.label || "SearchAcademicCalendars"}(
  $filter: SearchableResourceFilterInput
  $sort: [SearchableResourceSortInput!]
  $aggsNew: [SearchAggsInput!]
  $limit: Int
  $nextToken: String
  $authorizationContext: AuthorizationContextInput
) {
  searchAcademicCalendars(
    filter: $filter
    sort: $sort
    aggsNew: $aggsNew
    limit: $limit
    nextToken: $nextToken
    authorizationContext: $authorizationContext
  ) {
    items {
      ${params?.fields ?? ` id sk name idInc createdAt updatedAt `}
    }
    aggregations
    nextToken
    total
    __typename
  }
}
`;

export const searchCourseCalendars = (params?: Params) => /* GraphQL */ `
query ${params?.label || "SearchCourseCalendars"}(
  $filter: SearchableResourceFilterInput
  $sort: [SearchableResourceSortInput!]
  $aggsNew: [SearchAggsInput!]
  $limit: Int
  $nextToken: String
  $authorizationContext: AuthorizationContextInput
) {
  searchCourseCalendars(
    filter: $filter
    sort: $sort
    aggsNew: $aggsNew
    limit: $limit
    nextToken: $nextToken
    authorizationContext: $authorizationContext
  ) {
    items {
      ${params?.fields ?? ` id sk name idInc createdAt updatedAt `}
    }
    aggregations
    nextToken
    total
    __typename
  }
}
`;
